/** @format */

import { FC } from "react";
import styled from "styled-components";

interface SVGRProps {
  color?: string;
  transform?: string;
  width?: number;
}

const Svg = styled.svg`
  transform: ${({ transform }) => transform || undefined};
  height: auto;
`;

const LogoText: FC<SVGRProps> = ({
  color = "#FFD96B",
  width = 49,
  transform,
}) => (
  <Svg
    width={width}
    viewBox="0 0 49 17"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby="LogoText"
    transform={transform}
    style={{ cursor: "pointer" }}
  >
    <title>LogoText</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.06224 14.9378C1.94744 15.5574 3.45228 16 5.68741 16C9.95851 16 12.1272 14.3181 12.1272 11.1978C12.1272 8.56432 9.98064 7.41355 7.17012 6.81604C5.68741 6.48409 4.55878 6.39557 4.55878 5.57676C4.55878 4.84647 5.17842 4.47026 6.46196 4.47026C7.81189 4.47026 9.27248 5.13416 10.2241 6.01936C10.3126 6.08575 11.7953 5.02351 11.7953 3.78423C11.7953 3.0982 11.4412 2.47856 10.6445 1.9917C9.75934 1.43845 8.38728 1.06224 6.4177 1.06224C2.50069 1.06224 0.33195 2.81051 0.33195 5.7538C0.33195 8.71923 2.72199 9.64869 5.11203 10.1577C6.52835 10.4454 7.63485 10.6003 7.63485 11.4855C7.63485 12.2158 7.01521 12.592 5.66528 12.592C4.16044 12.592 2.36791 11.7953 1.46058 10.9544C1.30567 10.8437 0 11.9945 0 13.0567C0 13.7649 0.30982 14.4288 1.06224 14.9378ZM13.195 10.3347C13.195 13.8755 15.5408 16 19.2808 16C20.8299 16 22.0028 15.7344 22.8216 15.2697C23.6183 14.805 24.0609 14.1632 24.0609 13.4329C24.0609 11.8174 22.0692 11.751 22.047 11.7953C21.6487 12.5698 20.7414 13.1231 19.4357 13.1231C18.1743 13.1231 17.2227 12.5256 16.9129 11.4855C16.8686 11.397 16.8465 11.2863 16.8243 11.1757H23.8174C24.4813 11.1757 24.6584 10.7994 24.6805 10.1577V9.95851C24.6805 6.79391 22.3568 4.49239 19.0152 4.49239C15.6293 4.49239 13.195 6.97095 13.195 10.3347ZM20.8963 9.20609H16.8686C16.9793 8.05533 17.8202 7.21438 18.9488 7.21438C20.1217 7.21438 20.8299 7.94468 20.8963 9.20609ZM33.8921 4.49239C32.166 4.49239 31.0595 5.35546 30.2849 6.52835C29.953 5.15629 28.9793 4.60304 27.8728 4.60304C26.9876 4.60304 26.2351 4.93499 26.2351 5.0899V13.7427C26.2351 15.314 27.0097 15.8008 28.1604 15.8008H28.603C29.6874 15.8008 30.4841 15.2918 30.4841 13.7427V8.80775C30.7939 8.29876 31.3914 7.94467 32.1217 7.94467C33.0069 7.94467 33.5159 8.56432 33.5159 9.53804V13.7427C33.5159 15.314 34.3126 15.8008 35.4412 15.8008H35.8838C36.9903 15.8008 37.7649 15.2697 37.7649 13.7427V8.80775C37.7649 6.55048 36.7248 4.49239 33.8921 4.49239ZM40.9793 13.7427C40.9793 15.2697 41.7981 15.8008 42.9046 15.8008H43.325C44.4758 15.8008 45.2282 15.314 45.2282 13.7427V7.92254H45.9806C47.1314 7.92254 47.6846 7.41355 47.6846 6.48409V6.24066C47.6846 5.24481 47.1314 4.71369 45.9806 4.71369H45.0733V4.35961C45.0733 3.47441 45.4274 3.14246 46.1355 3.14246C46.6888 3.14246 47.1757 3.38589 47.4855 3.67358C47.5297 3.73997 48.3043 2.94329 48.3043 2.01383C48.3043 1.5491 48.1273 1.1065 47.7289 0.73029C47.2199 0.28769 46.4011 0 45.1618 0C42.7497 0 40.9793 1.01798 40.9793 4.40387V4.71369H40.5588C39.408 4.71369 38.8326 5.22268 38.8326 6.15214V6.39557C38.8326 7.41355 39.408 7.92254 40.5588 7.92254H40.9793V13.7427Z"
      fill={color}
    />
  </Svg>
);

export default LogoText;
